<template>
  <el-dialog title="自建库存" :visible.sync="dialogTableVisible" width="40%">
    <el-row class="border-bottom">
      <el-col class="line-height" :span="24">
        <el-col :span="4">账单周期：</el-col>
        <el-col :span="10">
          <el-select v-model="cycle" placeholder="请选择">
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-col>
      <el-col :span="24" class="margin-top2">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="shop" label="扣款店铺"></el-table-column>
          <el-table-column prop="Cardnumber" label="扣款金额"></el-table-column>
          <el-table-column prop="Bank" label="转换人民币"></el-table-column>
          <el-table-column prop="time" label="时间"></el-table-column>
        </el-table>
      </el-col>
      <el-col class="line-height" :span="24">
        <el-col :span="4">账单周期：30CNY</el-col>
        <el-col :span="10"></el-col>
      </el-col>
      <el-col class="line-height" :span="12">当前周期是否还款：是/否</el-col>
      <el-col class="line-height" :span="12">实还款金额：31CNY</el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogTableVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogTableVisible = false">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Xykrepayment",
  data() {
    return {
      dialogTableVisible: false,
      cycle: "",
      tableData: [
        {
          shop: "",
          Cardnumber: "",
          Bank: "",
          time: ""
        }
      ],
      stateList: [
        {
          value: "0",
          label: "1.20-2.20"
        }
      ]
    };
  },
  mounted() {},
  created() {},
  methods: {
    init() {
      this.dialogTableVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ {
  .el-dialog__body {
    padding: 13px 20px;
  }
}
.padding {
  padding: 5px 0;
}
.line-height {
  line-height: 35px;
}
.text-align {
  text-align: center;
  line-height: 30px;
}
img {
  width: 100%;
  height: 100%;
}
</style>